import { isMMCompanion } from '~server/utils/auth.utils';
import { ApiConfig } from '~shared/constants/api.config';

export const API_ACCOUNT_FLYOUT_ENDPOINT = () =>
  `${ApiConfig.SVC_BUYER_ACCOUNT_API_V1_URL()}/flyout${isMMCompanion() ? '?mcompanion=true' : ''}`;
